export default __webpack_public_path__ + "static/media/image21.80ab7af8.png";